function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useContext, useRef, useState, useImperativeHandle, forwardRef, useEffect } from "react";
import { motion } from "framer-motion";
import { Portal } from "react-portal";
import { FaTimes } from "react-icons/fa";
import Flicking from "@egjs/react-flicking";
import { useKey } from "rooks";
import { twMerge } from "tailwind-merge";
import { RoundIconButton } from "../../atoms";
import { ChevronRight } from "../../icons";
import { ImageContext } from "../../../context";
function $ImageLightbox(param, ref) {
    var defaultIndex = param.defaultIndex, open = param.open, images = param.images, onClose = param.onClose;
    var flickingRef = useRef(null);
    var _$ref = _slicedToArray(useState(defaultIndex !== null && defaultIndex !== void 0 ? defaultIndex : 0), 2), activeIndex = _$ref[0], setActiveIndex = _$ref[1];
    var ImageComponent = useContext(ImageContext).ImageComponent;
    useImperativeHandle(ref, function() {
        return {
            setActiveIndex: setActiveIndex
        };
    });
    var handlePrevious = function() {
        if (flickingRef.current) {
            flickingRef.current.disableInput();
            var moveToIndex = flickingRef.current.index - 1;
            var _$ref;
            flickingRef.current.moveTo(moveToIndex < 0 ? ((_$ref = images === null || images === void 0 ? void 0 : images.length) !== null && _$ref !== void 0 ? _$ref : 1) - 1 : moveToIndex).then(function() {
                var _$ref;
                (_$ref = flickingRef.current) === null || _$ref === void 0 ? void 0 : _$ref.enableInput();
            });
        }
    };
    var handleNext = function() {
        if (flickingRef.current) {
            flickingRef.current.disableInput();
            var _$ref;
            flickingRef.current.moveTo((flickingRef.current.index + 1) % ((_$ref = images === null || images === void 0 ? void 0 : images.length) !== null && _$ref !== void 0 ? _$ref : 0)).then(function() {
                var _$ref;
                (_$ref = flickingRef.current) === null || _$ref === void 0 ? void 0 : _$ref.enableInput();
            });
        }
    };
    var handleWillChange = function(event) {
        setActiveIndex(event.index);
    };
    useKey("Escape", function() {
        return onClose === null || onClose === void 0 ? void 0 : onClose();
    });
    useEffect(function() {
        if (open) {
            setTimeout(function() {
                var _$ref;
                (_$ref = flickingRef.current) === null || _$ref === void 0 ? void 0 : _$ref.forceUpdate();
            }, 0);
        }
    }, [
        open
    ]);
    var _$ref1;
    return /*#__PURE__*/ React.createElement(Portal, null, /*#__PURE__*/ React.createElement(motion.div, {
        variants: {
            hide: {
                opacity: 0
            },
            show: {
                opacity: 1
            }
        },
        initial: "hide",
        exit: "hide",
        animate: open ? "show" : "hide",
        className: twMerge("isolate fixed z-20 top-0 left-0 h-full w-full grid grid-cols-1 bg-gray-light pointer-events-none", open && "pointer-events-auto")
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 p-6 md:p-9"
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        "aria-label": "Close",
        className: "col-start-1 row-start-1 ml-auto self-start z-10",
        onClick: onClose
    }, /*#__PURE__*/ React.createElement(FaTimes, {
        className: "block"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "col-start-1 row-start-1 grid gap-4 grid-cols-1 grid-rows-[1fr_auto]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "h-full container px-0 grid gap-6 grid-cols-[auto_1fr_auto] items-center"
    }, /*#__PURE__*/ React.createElement(RoundIconButton, {
        "aria-label": "Previous",
        disabled: activeIndex <= 0,
        onClick: handlePrevious
    }, /*#__PURE__*/ React.createElement(ChevronRight, {
        className: "shrink-0 rotate-180"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "isolate grid grid-cols-1 grid-rows-[1fr_auto] gap-4 h-full"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "relative h-full"
    }, !!(images === null || images === void 0 ? void 0 : images.length) && /*#__PURE__*/ React.createElement("div", {
        className: "flex absolute top-0 left-0 h-full w-full"
    }, /*#__PURE__*/ React.createElement(Flicking, {
        ref: flickingRef,
        circular: true,
        moveType: "strict",
        defaultIndex: defaultIndex,
        onWillChange: handleWillChange
    }, images.map(function(image, index) {
        return /*#__PURE__*/ React.createElement("div", {
            key: [
                image.src,
                index
            ].join("-"),
            className: "flex items-center w-full h-full mx-4"
        }, /*#__PURE__*/ React.createElement(ImageComponent, _extends({
            className: "max-h-full max-w-full w-full h-full object-contain object-center pointer-events-none"
        }, image)));
    })))), /*#__PURE__*/ React.createElement("div", {
        className: "text-right"
    }, activeIndex + 1, "/", images === null || images === void 0 ? void 0 : images.length)), /*#__PURE__*/ React.createElement(RoundIconButton, {
        "aria-label": "Next",
        disabled: activeIndex >= ((_$ref1 = images === null || images === void 0 ? void 0 : images.length) !== null && _$ref1 !== void 0 ? _$ref1 : 1) - 1,
        onClick: handleNext
    }, /*#__PURE__*/ React.createElement(ChevronRight, {
        className: "shrink-0"
    })))))));
}
export var ImageLightbox = /*#__PURE__*/ forwardRef($ImageLightbox);

//# sourceMappingURL=ImageLightbox.js.map